
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';

interface WedgingScoreButtonsProps {
  onScoreChange: (score: number) => void;
}

const WedgingScoreButtons: React.FC<WedgingScoreButtonsProps> = ({
  onScoreChange,
}) => {
  const { t } = useTranslation('training');
  
  return (
    <>
      <Button 
        onClick={() => onScoreChange(4)} 
        className="h-14 text-base font-medium bg-green-600 hover:bg-green-700 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.wedging.ballIn')}
      </Button>
      <Button 
        onClick={() => onScoreChange(3)} 
        className="h-14 text-base font-medium bg-green-500 hover:bg-green-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.wedging.safeZone')}
      </Button>
      <Button 
        onClick={() => onScoreChange(2)} 
        className="h-14 text-base font-medium bg-yellow-500 hover:bg-yellow-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.wedging.ballAt3m')}
      </Button>
      <Button 
        onClick={() => onScoreChange(1)} 
        className="h-14 text-base font-medium bg-yellow-600 hover:bg-yellow-700 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.wedging.ballAt5m')}
      </Button>
      <Button 
        onClick={() => onScoreChange(0)} 
        className="h-14 text-base font-medium bg-red-500 hover:bg-red-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.wedging.ballOutside')}
      </Button>
    </>
  );
};

export default WedgingScoreButtons;
